<template>
	<div class="AppPieChart">
		<div class="pieChart">
			<div id="pieChart__s1" class="pieChart__s1" />
			<div class="pieChart__s2">
				<table class="tableMain">
					<tr class="text-xs">
						<th>
							Category
						</th>
						<th>
							<span>%</span>
						</th>
						<th>
							<span>Amount</span>
						</th>
					</tr>
					<tr class="text-xs">
						<td>category 1</td>
						<td>5%</td>
						<td>Amount 1</td>
					</tr>
					<tr class="text-xs">
						<td>category 1</td>
						<td>5%</td>
						<td>Amount 2</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>
<script>
import { Echarts } from "../../../../mixins/echarts.common";
export default {
	name: "AppPieChart",
	mounted() {
		this.showPieChart();
	},
	methods: {
		showPieChart() {
			let piechart = Echarts.echarts.init(
				document.getElementById("pieChart__s1")
			);
			var weatherIcons = {
				Sunny: "./data/asset/img/weather/sunny_128.png",
				Cloudy: "./data/asset/img/weather/cloudy_128.png",
				Showers: "./data/asset/img/weather/showers_128.png"
			};

			piechart.setOption({
				title: {
					text: "Title",
					subtext: "Subtext",
					x: "center"
				},
				tooltip: {
					trigger: "item",
					formatter: "{a} <br/>{b} : {c} ({d}%)"
				},
				legend: {
					orient: "vertical",
					left: "left",
					data: ["value1", "value2", "value3", "value4", "value5"]
				},
				series: [
					{
						name: "name",
						type: "pie",
						radius: "60%",
						center: ["50%", "60%"],
						data: [
							{ value: 335, name: "value1" },
							{ value: 310, name: "value2" },
							{ value: 234, name: "value3" },
							{ value: 135, name: "value4" },
							{ value: 1548, name: "value5" }
						],
						itemStyle: {
							emphasis: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: "rgba(0, 0, 0, 0.5)"
							}
						}
					}
				]
			});
		}
	}
};
</script>
<style lang="scss">
@import "../../../assets/css/variable.scss";
.AppPieChart {
	box-shadow: $app-card-shadow;
	border-radius: $app-border-radius;
	background: #fff;
	margin: 0.5rem auto;
	padding: 1rem;
}
.AppPieChart .pieChart {
	display: flex;
	justify-content: space-between;
}
.AppPieChart #pieChart__s1 {
	width: 50%;
	height: 400px;
	margin: 0 auto;
}
.AppPieChart .pieChart__s2 {
	align-self: center;
	width: 50%;
}
.AppPieChart .tableMain {
	margin: 0 auto;
	border: 1px solid $table-border-color;
	width: 97%;
	color: $amp-text-color2;
}
.AppPieChart .tableMain tr {
	padding: 0.5rem 0;
}
.AppPieChart .tableMain th {
	text-align: left;
	border-bottom: 2px solid $table-border-color !important;
	padding: 0.875rem 1.5rem;
	// background-color: #4CAF50;
	font-size: $table-heading;
}

.AppPieChart .tableMain th,
.AppPieChart .tableMain td {
	border: 1px solid $table-border-color;
	padding: 0.625rem;
	border-left: 0;
	padding-left: 1.5rem;
}
.AppPieChart .tableMain td {
	font-size: $table-td;
	font-weight: 400;
	line-height: 1.47;
}
</style>
